var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-12"
  }, [_c('h3', [_vm._v("Tinymce:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Language:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ar"
    }
  }, [_vm._v("Arabic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "be"
    }
  }, [_vm._v("Belarusian ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bn_BD"
    }
  }, [_vm._v("Bengali  (Bangladesh)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bg_BG"
    }
  }, [_vm._v("Bulgarian (Bulgaria)  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ca"
    }
  }, [_vm._v("Catalan ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh_CN"
    }
  }, [_vm._v("Chinese (China)  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh_TW"
    }
  }, [_vm._v("Chinese (Taiwan) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hr"
    }
  }, [_vm._v("Croatian ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cs"
    }
  }, [_vm._v("Czech ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "da"
    }
  }, [_vm._v("Danish ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dv"
    }
  }, [_vm._v("Divehi ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nl"
    }
  }, [_vm._v("Dutch ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en_CA"
    }
  }, [_vm._v("English (Canada) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en_GB"
    }
  }, [_vm._v("English (United Kingdom) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en_US"
    }
  }, [_vm._v("English (United States) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "et"
    }
  }, [_vm._v("Estonian ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr_FR"
    }
  }, [_vm._v("French (France)  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "gl"
    }
  }, [_vm._v("Galician ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ka_GE"
    }
  }, [_vm._v("Georgian (Georgia) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("German ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de_AT"
    }
  }, [_vm._v("German (Austria) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "el"
    }
  }, [_vm._v("Greek ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "he_IL"
    }
  }, [_vm._v("Hebrew (Israel) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hu_HU"
    }
  }, [_vm._v("Hungarian (Hungary)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ga"
    }
  }, [_vm._v("Irish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "it"
    }
  }, [_vm._v("Italian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ja"
    }
  }, [_vm._v("Japanese")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kab"
    }
  }, [_vm._v("Kabyle")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kk"
    }
  }, [_vm._v("Kazakh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "km_KH"
    }
  }, [_vm._v("Khmer (Cambodia) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ko_KR"
    }
  }, [_vm._v("Korean (Korea)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lv"
    }
  }, [_vm._v("Latvian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "nb_NO"
    }
  }, [_vm._v("Norwegian Bokmål (Norway)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fa_IR"
    }
  }, [_vm._v("Persian (Iran) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pl"
    }
  }, [_vm._v("Polish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt_BR"
    }
  }, [_vm._v("Portuguese (Brazil) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt_PT"
    }
  }, [_vm._v("Portuguese (Portugal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ro"
    }
  }, [_vm._v("Romanian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Russian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sr"
    }
  }, [_vm._v("Serbian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "si_LK"
    }
  }, [_vm._v("Sinhala (Sri Lanka) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sk"
    }
  }, [_vm._v("Slovak")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sl_SI"
    }
  }, [_vm._v("Slovenian (Slovenia)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es"
    }
  }, [_vm._v("Spanish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "es_MX"
    }
  }, [_vm._v("Spanish (Mexico)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sv_SE"
    }
  }, [_vm._v("Swedish (Sweden)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ta"
    }
  }, [_vm._v("Tamil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ta_IN"
    }
  }, [_vm._v("Tamil (India)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "th_TH"
    }
  }, [_vm._v("Thai (Thailand)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tr"
    }
  }, [_vm._v("Turkish")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tr_TR"
    }
  }, [_vm._v("Turkish (Turkey)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "uk"
    }
  }, [_vm._v("Ukrainian")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "uk_UA"
    }
  }, [_vm._v("Ukrainian (Ukraine) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "uz"
    }
  }, [_vm._v("Uzbek")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "vi_VN"
    }
  }, [_vm._v("Vietnamese (Viet Nam)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cy"
    }
  }, [_vm._v("Welsh")])])]), _vm._v(" "), _c('tinymce', {
    ref: "tm",
    attrs: {
      "id": "dt1",
      "toolbar2": _vm.toolbar2,
      "other_options": _vm.options1
    },
    on: {
      "editorInit": _vm.initCallBack,
      "editorChange": _vm.editorChange
    },
    model: {
      value: (_vm.dt1),
      callback: function($$v) {
        _vm.dt1 = $$v
      },
      expression: "dt1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-xs-12"
  }, [_c('h3', [_vm._v("Returned html code:")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetContent
    }
  }, [_vm._v("Reset content")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_vm._v("\n        " + _vm._s(_vm.dt1) + "\n        ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "id": "vue-logo",
      "src": require("../assets/logo.png")
    }
  }), _vm._v("\n        Easy use of tinymce in vue js\n        "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "https://github.com/dyonir/vue-tinymce-editor"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  }), _vm._v("\n            View on GitHub\n        ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ed9e269","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TinymceTest.vue
// module id = uCMe
// module chunks = 0